import React, { useState } from "react";
import "../css/report.css";
import { Box, Card, Typography } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, Tooltip as ReTooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from "recharts";

const locations = ["Newcastle", "London", "Manchester", "Birmingham"];
const testTypes = ["Outstation Testing", "Call Out Testing"];

const Report = () => {
  const [reportStartDate, setReportStartDate] = useState("");
  const [reportEndDate, setReportEndDate] = useState("");
  const [reportLocation, setReportLocation] = useState("");
  const [reportTestType, setReportTestType] = useState("");

  return (
    <Box className="report-main">
      <Card className="report-card">
        <div className="report-filters">
          <div>
            <label>Date Range:</label>
            <input type="date" value={reportStartDate} onChange={e => setReportStartDate(e.target.value)} />
            <input type="date" value={reportEndDate} onChange={e => setReportEndDate(e.target.value)} />
          </div>
          <div>
            <label>Location:</label>
            <select value={reportLocation} onChange={e => setReportLocation(e.target.value)}>
              <option value="">All</option>
              {locations.map(loc => <option key={loc} value={loc}>{loc}</option>)}
            </select>
          </div>
          <div>
            <label>Test Type:</label>
            <select value={reportTestType} onChange={e => setReportTestType(e.target.value)}>
              <option value="">All</option>
              {testTypes.map(type => <option key={type} value={type}>{type}</option>)}
            </select>
          </div>
          <div className="report-actions">
            <button className="download-btn">Download Excel</button>
            <button className="print-btn">Print Report</button>
          </div>
        </div>
        <Typography variant="h5" className="report-title">
          Job Report for {reportLocation || "All Locations"} {reportStartDate && reportEndDate ? `(${reportStartDate} to ${reportEndDate})` : ""}
        </Typography>
        <div className="report-table-wrapper">
          <table className="report-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Location</th>
                <th>CA</th>
                <th>D&A</th>
                <th>A Only</th>
                <th>Non-Neg Onsite</th>
                <th>AMP</th>
                <th>BAR</th>
                <th>COC</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2025-10-01</td>
                <td>Newcastle</td>
                <td>CA1</td>
                <td>2</td>
                <td>1</td>
                <td>0</td>
                <td>3</td>
                <td>0</td>
                <td>1</td>
                <td>All confirmed</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={5} className="report-total">Totals</td>
                <td className="report-total">3</td>
                <td className="report-total">3</td>
                <td className="report-total">1</td>
                <td className="report-total">1</td>
                <td className="report-total">-</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className="report-summary">
          <span>Total Tests: 8</span>
          <span>Confirmed Positives: 2</span>
          <span>Non-Neg Screens: 1</span>
        </div>
        <div className="report-charts">
          <div className="report-chart">
            <span>Positive Confirmed vs Non-Negative Screens</span>
            <ResponsiveContainer width="100%" height={180}>
              <BarChart data={[{ name: "Confirmed", value: 2 }, { name: "Non-Neg", value: 1 }] }>
                <XAxis dataKey="name" />
                <YAxis />
                <ReTooltip />
                <Bar dataKey="value" fill="#4180B7" radius={[10, 10, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
          <div className="report-chart">
            <span>Tests per Location</span>
            <ResponsiveContainer width="100%" height={180}>
              <PieChart>
                <Pie data={[{ name: "Newcastle", value: 5 }, { name: "London", value: 3 }]} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={60} label>
                  <Cell fill="#4180B7" />
                  <Cell fill="#80c209" />
                </Pie>
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      </Card>
    </Box>
  );
};

export default Report;
